"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.darkTheme = void 0;
var colors_1 = __importDefault(require("./colors"));
var chartColors_1 = __importDefault(require("./chartColors"));
var shadows_1 = __importDefault(require("./shadows"));
var sidebarColors_1 = __importDefault(require("./sidebarColors"));
var variables_1 = __importDefault(require("./variables"));
__exportStar(require("./colors"), exports);
__exportStar(require("./chartColors"), exports);
__exportStar(require("./shadows"), exports);
__exportStar(require("./sidebarColors"), exports);
__exportStar(require("./variables"), exports);
var dark_1 = require("./dark");
Object.defineProperty(exports, "darkTheme", { enumerable: true, get: function () { return __importDefault(dark_1).default; } });
var theme = {
    colors: colors_1.default,
    chartColors: chartColors_1.default,
    shadows: shadows_1.default,
    sidebarColors: sidebarColors_1.default,
    variables: variables_1.default
};
exports.default = theme;
//# sourceMappingURL=index.js.map